import { Box, Modal } from "@mui/material";
import React from "react";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { ForceCloseIcon } from "../../../assets/CommonAssets";
import { getItemStockInfoById } from "../../../Pharmacy/PharmacyServices";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  maxHeight: "90%",
  width: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  borderRadius: "10px",
  overflowY: "visible",
  p: 1,
};
function ItemInfoModal(props) {
  const [itemsBatchInfo, setOItemsBatchInfo] = React.useState([]);

  React.useEffect(() => {
    if (props?.itemId > 0) {
      getItemStockInfoById(props?.itemId)
        .then((response) => response?.data)
        .then((res) => {
          if (res?.result?.length > 0) {
            setOItemsBatchInfo(res?.result);
          } else {
            setOItemsBatchInfo([]);
          }
        })
        .catch((err) => err);
    }
  }, [props?.itemId]);

  return (
    <div>
      <Modal
        open={props?.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyles}>
          <div className="flex justify-between">
            <div className=" ">
              <div className="flex justify-center font-bold text-xl my-2 px-3">
                Item Info :&nbsp;{props?.itemName}
              </div>
            </div>
            <div className="flex items-center">
              {/* <CommonButton
                label={"Add New"}
                type={"button"}
                className={
                  "border border-customBlue text-customBlue px-3 h-9 rounded mr-5"
                }
                onClick={() => {}}
              /> */}
              <button
                onClick={() => {
                  props?.close();
                }}
                type="button"
              >
                <ForceCloseIcon />
              </button>
            </div>
          </div>
          {itemsBatchInfo?.length > 0 ? (
            <div className="my-2 ">
              <CommonDynamicTableNew
                highlightRow={false}
                dataResult={itemsBatchInfo}
              />
            </div>
          ) : (
            ""
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default ItemInfoModal;
